import { ArrowBack } from '@mui/icons-material';
import {
  Box,
  Grid,
  IconButton,
  IconButtonProps,
  Typography,
  useTheme,
} from '@mui/material';
import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import { Scan } from '../../../../services/entities/impl/blfApi/schemas/scan';
import { MapControl } from '../../../commonUI/maps/controls';
import { useBlueberryReportDateRangeKeys } from '../../../reports/blueberry/hooks/useBlueberryReportDateRangeKeys';
import { useNavigateWithReportDateRange } from '../../../reports/hooks/useNavigateWithReportDateRange';

export const ScanControl = ({
  scan,
  block,
}: {
  scan: Scan;
  block: Pick<Block, 'varietyID'>;
}) => {
  const dateRangeOptions = useBlueberryReportDateRangeKeys();
  const navigate = useNavigateWithReportDateRange(
    dateRangeOptions,
    undefined,
    scan.scanDate
  );

  const handleBackButtonClick = () => {
    navigate(`/reports/${block.varietyID}`);
  };

  return (
    <MapControl
      aria-label='Block Metadata'
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        width: 350,
        padding: 2,
      }}
    >
      <Grid container spacing={2} sx={{ padding: 2 }} columns={2}>
        <Grid
          size='auto'
          sx={{ display: 'flex', justifyContent: 'center', marginTop: 1 }}
        >
          <BackButton onClick={handleBackButtonClick} />
        </Grid>
        <Grid size={1}>
          <Typography variant='h6'>{scan.blockName}</Typography>
          <Typography variant='subtitle2' color='textSecondary'>
            {scan.scanDate}
          </Typography>
        </Grid>
      </Grid>
    </MapControl>
  );
};

const BackButton = ({ onClick }: Pick<IconButtonProps, 'onClick'>) => {
  const theme = useTheme();

  return (
    <Box>
      <IconButton size='small' onClick={onClick}>
        <ArrowBack
          htmlColor={theme.vars.palette.text.secondary}
          fontSize='inherit'
        />
      </IconButton>
    </Box>
  );
};
